const projects = {
  searchMember(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/search-member', Object.assign(defaults, { data }));
  },
  searchPolicy(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/search-policy', Object.assign(defaults, { data }));
  },

  searchGroup(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/search-group', Object.assign(defaults, { data }));
  },

  createProject(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects', Object.assign(defaults, { data }));
  },

  editProject(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${data.id}`, Object.assign(defaults, { data }));
  },

  deleteProject(projectId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}`, defaults);
  },

  addVersion(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${data.id}/create_version`, Object.assign(defaults, { data }));
  },

  editVersion(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/versions/${data.id}`, Object.assign(defaults, { data }));
  },

  deleteVersion(versionId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/versions/${versionId}`, defaults);
  },
  /*
  getProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects?page='.concat(data.page || '', '&limit=', data.limit || '', '&order=', data.order || '', '&project_id=', data.id || ''), Object.assign(defaults, { data }));
  },
  */
  getComProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/components', Object.assign(defaults, { data }));
  },
  getComProjectDetail(obj, projectId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/components`, Object.assign(defaults, { data }));
  },
  getSecProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/projects/securities', Object.assign(defaults, { data }));
  },
  getSecProjectDetail(obj, projectId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/projects/${projectId}/securities`, Object.assign(defaults, { data }));
  },
  getLicProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/licenses', Object.assign(defaults, { data }));
  },
  getLicProjectDetail(obj, projectId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/licenses`, Object.assign(defaults, { data }));
  },
  getOverviewProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/uploadeds', Object.assign(defaults, { data }));
  },

  getOverviewUploadedList(obj, projectId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/reports`, Object.assign(defaults, { data }));
  },
  getPolicyProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/policies', Object.assign(defaults, { data }));
  },
  getPolicyUploadedList(obj, projectId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/policies`, Object.assign(defaults, { data }));
  },
  /*
  getSProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/settings?page='.concat(data.page || '', '&limit=', data.limit || '', '&order=', data.order || '', '&project_id=', data.id || ''), Object.assign(defaults, { data }));
  },
*/
  getSProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/settings', Object.assign(defaults, { data }));
  },
  getSProjectVersionDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/settings_version?project_id=${projectId}`, defaults);
  },
  getSProjectFileDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/settings_uploaded?project_id=${projectId}`, defaults);
  },
  getSProjectMemberDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/settings_member?project_id=${projectId}`, defaults);
  },
  getProjectDetail(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/edit`, defaults);
  },

  getVersionList(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/versions`, defaults);
  },

  getScanProjectList() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/projects/scan_config', defaults);
  },

  getScanVersionList(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${projectId}/scan_version_config`, defaults);
  },

  getInfo(data) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/${data.contentType}/${data.contentId}`, defaults);
  },
  getProjectTree(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/reports/p_tree', Object.assign(defaults, { data }));
  },
  getLeftProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/left_project_list', Object.assign(defaults, { data }));
  },
  getProjectExportList(project_id) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/${project_id}/export`, defaults);
  },
  postProjectExportReport(obj, project_id) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/projects/${project_id}/export`, Object.assign(defaults, { data }), '', true);
  },
  getProjectFilters() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/project_filters', defaults);
  },
  createProjectFilter(obj) {
    const data = obj;
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/project_filters/create', Object.assign(defaults, { data }));
  },
  deleteProjectFilter(filterids) {
    const data = filterids;
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/project_filters/destroy_selected', Object.assign(defaults, { data }));
  },
  fetchUserDefinedProjectSettings(projectId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/projects/settings_user_defined?project_id=${projectId}`, defaults);
  },
  getProjectExportSettings(project_id) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/projects/${project_id}/export_setting`, Object.assign(defaults), '', true);
  },
};

export default projects;
